import React, { FunctionComponent, useState } from 'react';
import NavigationBarContext from '../context/NavigationBarContext';

const NavigationBarContextProvider: FunctionComponent = ({ children }) => {
  const [selectedActiveSectionName, setSelectedActiveSectionName] = useState('');

  return (
    <NavigationBarContext.Provider
      value={{
        selectedActiveSectionName,
        setSelectedActiveSectionName,
      }}
    >
      {children}
    </NavigationBarContext.Provider>
  );
};

export default NavigationBarContextProvider;
